import React from 'react'
import moment from 'moment'

import {Row, H6, H5, ScrollView, P, S2, Colors, Alert, Button, IconButton, Modal, ModalHeader, ModalActions, Popup} from '../UI/index.js'
import {formSpacing, FormRow, FormStack, Input, Select, TextArea, DatePicker, TimePicker, MetricInput, Recurrence} from '../UI/forms/index.js'
import NewShift from './NewShift.js'
import {emit} from 'src/socketio/socketEmit.js'
import Languages from '@utils/Languages.js'
import ChooseLocation from '@components/shifts/ChooseLocation.js'
import time from 'server/utils/time.js'
import DividerHeader from '@components/UI/surfaces/DividerHeader.js'
import t from 'src/helpers/Languages.js'
import _ from 'lodash'
import {getAvailableBranches} from 'src/utils/branches.js'

class EditShiftModal extends React.Component {
    constructor(props) {
        super(props)

        this.initialState = {
            modalIsOpen: false,
            shift: NewShift(),
            isTemplate: false,
            loading: false,
            error: ''
        }

        this.state = structuredClone(this.initialState)
    }

    open(shift, isTemplate) {
        shift = shift ? structuredClone(shift) : NewShift()

        if (isTemplate && !shift.date) {
            shift.date = shift.startDate
        }

        if (isTemplate && shift._id) {
            console.log(shift)
        }

        this.setState({modalIsOpen: true, shift, isTemplate}, () => {
            if (isTemplate && !shift.rrule) {
                shift.rrule = this.recurrence.init()

                this.setState({shift})
            }
        })
    }

    close() {
        this.setState(this.initialState)
    }

    async onSubmit(event) {
        event.preventDefault()
        let {shift, isTemplate} = this.state
        const {onClickView} = this.props

        try {
            if (isTemplate) {
                if (shift._id) {
                    this.popup.setInput({
                        type: 'date',
                        value: shift.startDate > time.today() ? shift.startDate : time.today(),
                        minDate: shift.startDate > time.today() ? shift.startDate : time.today(),
                        maxDate: shift.endDate,
                        label: Languages.date['NL']
                    })

                    const date = await this.popup.open('Dienst template wijzigen', 'Kies de datum vanaf wanneer deze wijziging van toepassing is.')
                    if (date === undefined) return
                    this.popup.close()

                    this.setState({loading: true, error: ''})
                    await emit('shifts.editTemplate', shift, date)
                } else {
                    this.setState({loading: true, error: ''})
                    await emit('shifts.createTemplate', shift)
                }
            } else {
                if (shift._id) {
                    this.setState({loading: true, error: ''})
                    ; ({data: shift} = await emit('shifts.edit', shift))
                } else {
                    this.setState({loading: true, error: ''})
                    ; ({data: shift} = await emit('shifts.create', shift))
                }

                if (shift._id) {
                    onClickView(shift._id)
                }
            }

            this.close()
        } catch (err) {
            this.setState({loading: false, error: err.message})
        }
    }

    onChangeValue(path, event) {
        const {shift} = this.state

        if (path === 'rrule') {
            if (!event.target.value) {
                delete shift.rrule
            } else {
                shift.rrule = event.target.value
            }
        } else {
            _.set(shift, path, event.target.value)
        }

        this.setState({shift})
    }

    onChangeShiftbaseDepartment(event) {
        const {shift} = this.state

        // Teams and Shiftbase shifts belong to a department
        if (event.target.value !== shift.meta?.shiftbaseDepartmentId) {
            shift.meta = {...shift.meta, shiftbaseDepartmentId: event.target.value, shiftbaseTeamId: '', shiftbaseShiftId: ''}
        }

        this.setState({shift})
    }

    /** A team and Shiftbase shift belong to a department, so choosing one also stores the inherited department on the shift. */
    onChangeShiftbaseValue(key, departmentId, event) {
        const {shift} = this.state

        shift.meta = {
            ...shift.meta,
            [key]: event.target.value,
            ...(event.target.value && departmentId && {shiftbaseDepartmentId: departmentId})
        }

        this.setState({shift})
    }

    onChangeValues(path, event) {
        const {shift} = this.state

        _.set(shift, path, event.target.values)

        this.setState({shift})
    }

    onChangeChecked(key, event) {
        const {shift} = this.state

        if (key.split('.').length === 2) {
            shift[key.split('.')[0]][key.split('.')[1]] = event.target.checked
        } else {
            shift[key] = event.target.checked
        }

        this.setState({shift})
    }

    render() {
        const {modalIsOpen, shift, isTemplate, error, loading} = this.state
        const {reseller, users, customers, routeTemplates = {}} = this.props

        const startShiftBeforeStartTimeLabels = {
            allowed: Languages.allowed['NL'],
            allowedmargin: Languages.allowedWithMargin['NL'],
            notallowed: Languages.notAllowed['NL']
        }

        // Without its own department or team, a shift inherits them from the courier or customer they are taken from
        const shiftbase = reseller.settings.shifts?.shiftbase
        const inheritedFrom = (connectedTo) => connectedTo === 'user' ? {meta: users[shift.messengerId]?.meta, title: 'Van koerier'} : connectedTo === 'customer' ? {meta: customers[shift.customerId]?.meta, title: 'Van klant'} : {}
        const inheritedDepartment = inheritedFrom(shiftbase?.departmentConnectedTo)
        const inheritedTeam = inheritedFrom(shiftbase?.teamConnectedTo)
        const inheritedDepartmentId = inheritedDepartment.meta?.shiftbaseDepartmentId
        const inheritedTeamId = inheritedTeam.meta?.shiftbaseTeamId
        const shiftbaseDepartmentId = shift.meta?.shiftbaseDepartmentId || inheritedDepartmentId
        const shiftbaseDepartmentPlaceholder = inheritedDepartmentId ? inheritedDepartment.title : undefined
        const shiftbaseTeamPlaceholder = inheritedTeamId ? inheritedTeam.title : undefined

        return (
            <Modal show={modalIsOpen} onClose={this.close.bind(this)}>
                <ModalHeader
                    title={isTemplate ?
                        (shift._id ? 'Bewerk dienst template ' : 'Nieuw dienst template') :
                        (shift._id ? 'Bewerk dienst' : 'Nieuwe dienst')
                    }
                    onClose={this.close.bind(this)}
                />

                <form onSubmit={this.onSubmit.bind(this)}>
                    <FormStack style={{marginBottom: formSpacing.section}}>
                        {(getAvailableBranches(reseller).length > 0 || !isTemplate) &&
                            <FormRow>
                                {getAvailableBranches(reseller).length > 0 &&
                                    <Select
                                        label={t('branch')}
                                        value={shift.branchId || ''}
                                        options={getAvailableBranches(reseller).map((branch) => {
                                            return {value: branch.id, title: branch.name}
                                        })}
                                        disabled={shift.customerId}
                                        allowEmpty
                                        onChange={(event) => this.setState({shift: {...shift, branchId: event.target.value}})}
                                    />
                                }

                                {!isTemplate ?
                                    <DatePicker
                                        label={Languages.date['NL']}
                                        value={shift.date}
                                        onChange={this.onChangeValue.bind(this, 'date')}
                                    /> :
                                    <div style={{flex: 1}} />
                                }
                            </FormRow>
                        }

                        <Input
                            label='Naam'
                            value={shift.name}
                            onChange={(event) => this.setState({shift: {...shift, name: event.target.value}})}
                        />

                        <Select
                            label='Klant'
                            allowEmpty
                            options={Object.values(customers).filter((customer) => !customer.isArchived).map((customer) => ({value: customer._id, title: customer.name}))}
                            value={shift.customerId}
                            onChange={(event) => {
                                const customerId = event.target.value
                                const selectedCustomer = customers[customerId]

                                this.setState({shift: {...shift, customerId, branchId: customerId ? (selectedCustomer?.branchId || '') : shift.branchId}})
                            }}
                        />

                        {isTemplate &&
                            <FormRow>
                                <DatePicker
                                    label={isTemplate ? Languages.startDate['NL'] : Languages.date['NL']}
                                    value={shift.date}
                                    minDate={isTemplate ? time.today() : undefined}
                                    disabled={isTemplate && shift._id}
                                    onChange={this.onChangeValue.bind(this, 'date')}
                                />

                                <DatePicker
                                    label={Languages.endDate['NL']}
                                    value={shift.endDate}
                                    minDate={(shift.date && shift.date > time.today()) ? shift.date : time.today()}
                                    allowEmpty={true}
                                    onChange={this.onChangeValue.bind(this, 'endDate')}
                                />
                            </FormRow>
                        }

                        {isTemplate &&
                            <Recurrence
                                direction='row'
                                date={shift.date}
                                rrule={shift.rrule}
                                onChange={this.onChangeValue.bind(this, 'rrule')}
                                ref={(ref) => this.recurrence = ref}
                            />
                        }

                        <FormRow>
                            <TimePicker
                                label={Languages.startTime['NL']}
                                value={shift.plannedStartTime}
                                onChange={this.onChangeValue.bind(this, 'plannedStartTime')}
                                allowEmpty
                            />

                            <TimePicker
                                label={Languages.endTime['NL']}
                                info='Vul hier de verwachte eindtijd in. De dienst blijft ook na deze eindtijd nog actief. De uitgevoerde eindtijd wordt bepaald door het afronden van de dienst.'
                                value={shift.plannedEndTime}
                                onChange={this.onChangeValue.bind(this, 'plannedEndTime')}
                                allowEmpty
                            />
                        </FormRow>

                        <FormRow>
                            <Select
                                label={Languages.startShiftBeforeStartTime['NL']}
                                info='Bepaalt of de koerier deze dienst kan starten voordat de geplande starttijd.'
                                value={shift.startShiftBeforeStartTime || ''}
                                onChange={this.onChangeValue.bind(this, 'startShiftBeforeStartTime')}
                            >
                                <option value=''>{`Gebruik standaard instelling (${startShiftBeforeStartTimeLabels[reseller.settings.shifts.startShiftBeforeStartTime]})`}</option>
                                <option value='allowed'>{Languages.allowed['NL']}</option>
                                <option value='allowedmargin'>{Languages.allowedWithMargin['NL']}</option>
                                <option value='notallowed'>{Languages.notAllowed['NL']}</option>
                            </Select>

                            <MetricInput
                                label={t('startShiftBeforeStartTimeMargin')}
                                info={t('startShiftBeforeStartTimeMarginInfo')}
                                append='min'
                                min={0}
                                value={shift.startShiftBeforeStartTime ? shift.startShiftBeforeStartTimeMargin : reseller.settings.shifts.startShiftBeforeStartTimeMargin}
                                disabled={shift.startShiftBeforeStartTime !== 'allowedmargin'}
                                onChange={this.onChangeValue.bind(this, 'startShiftBeforeStartTimeMargin')}
                            />
                        </FormRow>

                        <ChooseLocation
                            label={Languages.startLocation['NL']}
                            value={shift.startPoint}
                            reseller={reseller}
                            customer={customers[shift.customerId]}
                            onChange={(startPoint) => {
                                this.setState({shift: {...shift, startPoint}})
                            }}
                            allowCustomAddress
                            allowEmpty
                        />

                        <ChooseLocation
                            label={Languages.endLocation['NL']}
                            value={shift.endPoint}
                            reseller={reseller}
                            customer={customers[shift.customerId]}
                            onChange={(endPoint) => {
                                this.setState({shift: {...shift, endPoint}})
                            }}
                            allowCustomAddress
                            allowEmpty
                        />

                        <FormRow>
                            <Select
                                label='Koerier'
                                allowEmpty
                                options={Object.values(users).map((user) => {
                                    return {value: user._id, title: user.name}
                                })}
                                value={shift.messengerId}
                                onChange={this.onChangeValue.bind(this, 'messengerId')}
                            />

                            <TextArea
                                label='Instructies'
                                value={shift.instructions}
                                onChange={this.onChangeValue.bind(this, 'instructions')}
                            />
                        </FormRow>

                        <Select
                            label='Route templates'
                            info='Routes op dezelfde datum als de dienst krijgen automatisch dezelfde koerier toegewezen.   '
                            values={shift.routeTemplateIds || []}
                            options={Object.values(routeTemplates).filter((routeTemplate) => !routeTemplate.removed).map((routeTemplate) => ({
                                value: routeTemplate._id,
                                title: routeTemplate.name
                            }))}
                            onChange={(event) => {
                                this.setState({shift: {...shift, routeTemplateIds: event.target.values}})
                            }}
                        />
                    </FormStack>

                    {reseller.shiftTargetsEnabled &&
                        <>
                            <H6 style={{marginBottom: 12, marginTop: 24}}>{Languages.targets['NL']}</H6>

                            {shift.targets?.map((target, index) => {
                                return (
                                    <FormRow key={index} style={{alignItems: 'center', marginBottom: formSpacing.rowGap}}>
                                        <Select
                                            label={Languages.type['NL']}
                                            value={target.type}
                                            options={[
                                                {value: 'stopsPerHour', title: t('stopsPerHour')}
                                            ]}
                                            onChange={(event) => {
                                                const targets = [...shift.targets]
                                                targets[index].type = event.target.value
                                                this.setState({shift: {...shift, targets}})
                                            }}

                                        />
                                        <Input
                                            type='number'
                                            label={Languages.target['NL']}
                                            value={target.value}
                                            onChange={(event) => {
                                                const targets = [...shift.targets]
                                                targets[index].value = +event.target.value
                                                this.setState({shift: {...shift, targets}})
                                            }}
                                        />

                                        <IconButton
                                            icon='mdi mdi-delete'
                                            onClick={() => {
                                                const targets = [...shift.targets]
                                                targets.splice(index, 1)
                                                this.setState({shift: {...shift, targets}})
                                            }}
                                        />
                                    </FormRow>
                                )
                            })}

                            <Button
                                variant='outline'
                                label={Languages.addTarget['NL']}
                                icon='mdi mdi-plus'
                                disabled={shift.targets?.length === 1}
                                onClick={() => {
                                    const targets = shift.targets ? [...shift.targets] : []
                                    targets.push({type: 'stopsPerHour', value: 0})
                                    this.setState({shift: {...shift, targets}})
                                }}
                            />
                        </>
                    }

                    <H6 style={{marginBottom: 12, marginTop: 24}}>{t('administration')}</H6>

                    <FormRow style={{marginBottom: formSpacing.rowGap}}>
                        <Select
                            label={t('priceTable')}
                            value={shift.priceTableId}
                            onChange={this.onChangeValue.bind(this, 'priceTableId')}
                            allowEmpty
                            options={(reseller.settings.shifts.prices || []).map((priceTable) => ({value: priceTable.id, title: priceTable.name}))}
                        />

                        <Input
                            label={t('reference')}
                            value={shift.reference}
                            onChange={this.onChangeValue.bind(this, 'reference')}
                        />
                    </FormRow>

                    {reseller.settings.shifts?.shiftbase?.enabled &&
                        <>
                            <H5 style={{marginBottom: 24, marginTop: 24}}>Shiftbase</H5>

                            <FormStack style={{marginBottom: formSpacing.rowGap}}>
                                <FormRow>
                                    <Select
                                        label='Shiftbase afdeling'
                                        fetch={async () => {
                                            const response = await fetch('https://api.shiftbase.com/api/departments', {
                                                headers: {
                                                    'Content-Type': 'application/json',
                                                    'Accept': 'application/json',
                                                    'Authorization': `API ${reseller.settings.shifts.shiftbase.apiKey}`
                                                }
                                            })

                                            const shiftbaseDepartments = (await response.json())?.data || []

                                            return shiftbaseDepartments.map((department) => {
                                                return {
                                                    title: department.Department.name,
                                                    value: department.Department.id
                                                }
                                            })
                                        }}
                                        // The placeholder is the title of the empty option, so the options are fetched again when it changes
                                        fetchTrigger={shiftbaseDepartmentPlaceholder || ''}
                                        value={shift.meta?.shiftbaseDepartmentId || ''}
                                        onChange={this.onChangeShiftbaseDepartment.bind(this)}
                                        placeholder={shiftbaseDepartmentPlaceholder}
                                        allowEmpty
                                    />

                                    <Select
                                        label='Shiftbase team'
                                        disabled={!shiftbaseDepartmentId}
                                        fetch={async () => {
                                            if (!shiftbaseDepartmentId) {
                                                return []
                                            }

                                            const response = await fetch(`https://api.shiftbase.com/api/departments/${shiftbaseDepartmentId}`, {
                                                headers: {
                                                    'Content-Type': 'application/json',
                                                    'Accept': 'application/json',
                                                    'Authorization': `API ${reseller.settings.shifts.shiftbase.apiKey}`
                                                }
                                            })

                                            const shiftbaseDepartment = (await response.json())?.data || {}

                                            return shiftbaseDepartment.Team?.map((team) => {
                                                return {
                                                    title: team.name,
                                                    value: team.id
                                                }
                                            }) || []
                                        }}
                                        fetchTrigger={`${shiftbaseDepartmentId || ''}${shiftbaseTeamPlaceholder || ''}`}
                                        value={shift.meta?.shiftbaseTeamId || ''}
                                        onChange={this.onChangeShiftbaseValue.bind(this, 'shiftbaseTeamId', shiftbaseDepartmentId)}
                                        placeholder={shiftbaseTeamPlaceholder}
                                        allowEmpty
                                    />
                                </FormRow>

                                <FormRow style={{marginBottom: formSpacing.section}}>
                                    <Select
                                        label='Shiftbase dienst'
                                        disabled={!shiftbaseDepartmentId}
                                        fetch={async () => {
                                            if (!shiftbaseDepartmentId) {
                                                return []
                                            }

                                            const response = await fetch(`https://api.shiftbase.com/api/departments/${shiftbaseDepartmentId}`, {
                                                headers: {
                                                    'Content-Type': 'application/json',
                                                    'Accept': 'application/json',
                                                    'Authorization': `API ${reseller.settings.shifts.shiftbase.apiKey}`
                                                }
                                            })

                                            const shiftbaseDepartment = (await response.json())?.data || {}

                                            return shiftbaseDepartment.Shift?.map((shift) => {
                                                return {
                                                    title: shift.long_name,
                                                    value: shift.id
                                                }
                                            }) || []
                                        }}
                                        fetchTrigger={shiftbaseDepartmentId}
                                        value={shift.meta?.shiftbaseShiftId || ''}
                                        onChange={this.onChangeShiftbaseValue.bind(this, 'shiftbaseShiftId', shiftbaseDepartmentId)}
                                        allowEmpty
                                    />

                                    <div style={{flex: 1}} />
                                </FormRow>
                            </FormStack>
                        </>
                    }

                    <H6 style={{marginBottom: 12, marginTop: 24}}>Emailnotificatie</H6>

                    <FormStack style={{marginBottom: formSpacing.rowGap}}>
                        <Select
                            label='Waarschuwing bij te laat starten dienst'
                            value={typeof shift.lateStartSettings?.warning !== 'string' ? 'default' : shift.lateStartSettings.warning}
                            onChange={(event) => this.onChangeValue('lateStartSettings.warning', event)}
                        >
                            <option value='default'>Gebruik standaard instellingen</option>
                            <option value=''>Geen</option>
                            <option value='os'>OS notificatie</option>
                            <option value='email'>Email</option>
                            <option value='both'>OS notificatie + email</option>
                        </Select>

                        {(shift.lateStartSettings?.warning === 'email' || shift.lateStartSettings?.warning === 'both') && (
                            <Select
                                label='Ontvanger(s) email meldingen'
                                info='Laat leeg om de standaardinstelling te gebruiken'
                                values={shift.lateStartSettings?.recipients || []}
                                options={[
                                    ...(users && Object.keys(users).length > 0 ? Object.values(users).map((user) => ({value: user._id, title: user.name})) : [])
                                ]}
                                allowCustomValues
                                onChange={(event) => {
                                    this.onChangeValues('lateStartSettings.recipients', event)
                                }}
                            />
                        )}
                    </FormStack>

                    {isTemplate && shift._id && (
                        <DividerHeader title='Historie' defaultHidden style={{marginBottom: 18, marginTop: 12}}>
                            <ScrollView style={{maxHeight: 250}}>
                                {[...shift.history || []].reverse().map((entry, index) => (
                                    <Row key={`history-${index}`} style={{alignItems: 'center', flexShrink: 0}}>
                                        <div style={{height: 10, width: 10, borderRadius: '50%', marginRight: 15, background: Colors.grey20}} />

                                        <Row style={{flex: 1, paddingLeft: 6, paddingRight: 6, minWidth: 'auto'}}>
                                            {entry.description ?
                                                (
                                                    <P style={{whiteSpace: 'pre'}}>{entry.description}</P>
                                                ) :
                                                entry.type === 'create' ?
                                                    (
                                                        <P>Template aangemaakt</P>
                                                    ) :
                                                    entry.type === 'update' ?
                                                        (
                                                            <P>Template bijgewerkt</P>
                                                        ) :
                                                        null}
                                        </Row>

                                        <Row style={{paddingLeft: 6, paddingRight: 6, width: 200, minWidth: 'auto'}}>
                                            <S2>{`${entry.who} | ${entry.timestamp ? moment(entry.timestamp).format('DD-MM-YYYY HH:mm:ss') : undefined}`}</S2>
                                        </Row>
                                    </Row>
                                ))}
                            </ScrollView>
                        </DividerHeader>
                    )}

                    {error && <Alert style={{marginBottom: 6}} variant='danger'>{error}</Alert>}

                    <ModalActions>
                        <Button loading={loading} type='submit'>Opslaan</Button>
                    </ModalActions>
                </form>

                <Popup ref={(ref) => this.popup = ref} />
            </Modal>
        )
    }
}

export default EditShiftModal
